/**
 * Use of @babel/polyfill is deprecated, directly importing core-js/stable is the replacement.
 * Since we use @babel/core > 7.18, there's no need to also import 'regenerator-runtime/runtime' for async transpilation
 *
 * More info;
 * https://github.com/babel/ember-cli-babel/blob/master/UPGRADING.md#v8
 * https://babeljs.io/docs/babel-polyfill
 * https://github.com/zloirock/core-js#babelpolyfill
 */
import 'core-js/stable'

import Application from '@ember/application'
import Resolver from 'ember-resolver'
import loadInitializers from 'ember-load-initializers'
import config from 'district-ui-client/config/environment'
import '@blakeelearning/fidget/styles/addon.css'
import '@blakeelearning/popovers/styles/addon.css'
import setupInspector from '@embroider/legacy-inspector-support/ember-source-4.12'
// Import app CSS last, so that it is higher priority when styles are equal specificity
import '@css/app.css'

import '@warp-drive/ember/install'

import compatModules from '@embroider/virtual/compat-modules'

export default class App extends Application {
  modulePrefix = config.modulePrefix

  podModulePrefix = config.podModulePrefix

  Resolver = Resolver.withModules(compatModules)

  inspector = setupInspector(this)
}

loadInitializers(App, config.modulePrefix, compatModules)
